export function normalizeFieldExtraData(rawExtraData) {
  if (rawExtraData?.isNormalised) {
    return rawExtraData
  }

  if (rawExtraData && typeof rawExtraData === 'object') {
    return {
      options: [],
      ...rawExtraData,
      isNormalised: true,
    }
  }

  try {
    const extraData = JSON.parse(rawExtraData || '{}')

    return {
      options: [],
      ...extraData,
      isNormalised: true,
    }
  } catch {
    return {
      options: [],
      fieldType: rawExtraData || undefined,
      isNormalised: true,
    }
  }
}

export const fieldCommonProps = {
  modelValue: {
    type: [String, Number, Boolean, Array],
    default: '',
  },
  field: {
    type: Object,
    required: true,
  },
  mode: {
    type: String,
    validator: value => ['edit', 'view'].includes(value),
    default: 'edit',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  hasExternalError: {
    type: Boolean,
    default: false,
  },

  externalRequired: {
    type: Boolean,
    default: undefined,
  },
}

export function getTooltipText(props) {
  return normalizeFieldExtraData(props?.field?.extraData)?.tooltipText || ''
}
